import React from 'react';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/stores/Root';
import CartItemSummary from '../../summary/CartItemSummary';
import CartTotalSummary from '../../summary/CartTotalSummary';
import Divider from '../../content/Divider';
import Avatar from '../../content/Avatar';
import PromoCode from '../../input/PromoCode';
import AppliedDiscountsList from '../../summary/AppliedDiscountsList';

const CartSummarySection: React.FC = observer(() => {
  const rootStore = useMst();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { configuration, cart } = rootStore;

  const handleApplyPromoCodeClicked = async (promoCode: string) => {
    await cart.applyPromoCode(promoCode);
    return cart.getPromoCodeApplyResult(promoCode);
  };

  return (
    <div className="max-h-screen md:max-w-md md:min-w-min flex flex-col">
      <div className="mt-4 flex-none">
        <div className="flex flex-row justify-center space-x-4">
          <div className="mt-2 text-2xl summary-panel-order">Your Cart</div>
          <Avatar>{cart?.totals?.qty || cart?.cartData?.items?.length}</Avatar>
        </div>
      </div>
      <div className="container summary-panel-cart overflow-y-auto border rounded-md py-2 px-5 my-2 md:max-h-screen-50">
        <CartItemSummary
          currencySymbol={configuration.formattedCurrencySymbol}
        />
      </div>
      <div className="flex-none mb-6 mt-8">
        <Divider />
        <AppliedDiscountsList />
        <PromoCode
          appliedCouponCodes={cart.appliedCouponCodes}
          onPromoCodeApplyClicked={handleApplyPromoCodeClicked}
        />
        <CartTotalSummary
          currencySymbol={configuration.formattedCurrencySymbol}
          discountTotal={cart.discountTotal}
          giftCards={cart.totals.giftCards}
          subTotal={cart.subTotal}
          shippingTotal={
            rootStore.showTaxAndShipping ? cart.shippingTotal : undefined
          }
          taxTotal={cart.taxTotal}
          grandTotal={cart.totals.grandTotal}
          giftCardAmountUsed={cart.giftCardAmountUsed}
        />
      </div>
    </div>
  );
});

export default CartSummarySection;
